// extracted by mini-css-extract-plugin
export default {"tableWrapper":"UTable_tableWrapper__a3A3g","tableContainer":"UTable_tableContainer__p-5gv","customTable":"UTable_customTable__-keP-"};